<template>
  <banner
    v-if="shoRenewPasswordHelpMessage"
    color-scheme="alert"
    :banner-message="$t('PROFILE_SETTINGS.CHANGE_PASSWORD_HELP_TEXT')"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from 'dashboard/components/ui/Banner';

export default {
  components: { Banner },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    shoRenewPasswordHelpMessage() {
      const isProfileSettingRoute = this.$route.matched.some(
        ({ name }) => name === 'profile_settings_index'
      );
      const { currentUser } = this;
      return (
        isProfileSettingRoute &&
        currentUser.password_attr.pass_expired &&
        currentUser.password_attr.reset
      );
    },
  },

  methods: {},
};
</script>
